<template>
    <div class="resident-warpper">
        <div class="bg-white">
          <!-- 第一部分：活动基本信息 -->
          <div class="activity-header">
            <div class="activity-basic-info">
              <h1 class="activity-name">{{info.name}}</h1>
              <div class="info-item">
                <span class="info-label">活动时间：</span>
                <span class="info-value">{{info.time}}</span>
              </div>
              <div class="info-item">
                <span class="info-label">活动地址：</span>
                <span class="info-value">{{info.address}}</span>
              </div>
              <div class="info-item">
                <span class="info-label">签到人数：</span>
                <span class="info-value">
                  <span class="sign-count">{{info.sign_count}}人</span>
                </span>
              </div>
            </div>
          </div>

          <!-- 活动介绍 -->
          <div class="section-block">
            <h2 class="section-title">活动介绍</h2>
            <div class="intro-content" v-html="info.content"></div>
          </div>

          <!-- 签到人名 -->
          <div class="section-block">
            <h2 class="section-title">签到人名</h2>
            <div class="sign-users-list">
              <span class="user-tag" v-for="(item,index) in info.sign_name" :key="index">{{item}}</span>
            </div>
          </div>

          <!-- 活动照片 -->
          <div class="section-block">
            <h2 class="section-title">活动照片</h2>
            <div class="photo-grid">
              <div class="photo-item" v-for="(item,index) in info.images" :key="index">
                <img :src="item.url" :alt="item.name">
              </div>

            </div>
          </div>
          <div class="flex align-center justify-center margin-top-lg">
            <el-button :loading="export_loading" type="primary" @click="exportData" style="width: 200px;">导出</el-button>
          </div>
        </div>
    </div>
</template>

<script>
import {getActiveDetail} from "@/api/gzh";
import {upFeil} from "@/config";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            FILE_URL: upFeil,
            keyword: '',
            detail_id: '',
          info:{
            sign_name:[],
            content:'',
            address:'',
            time:'',
            name:'',
            images:[]
          },
            export_loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/home/gzh/active', "双暖为老 / 活动列表 / 报名详情", true);
        this.detail_id = this.$route.params.id
      this.getDetail()
    },
    methods: {
      //  获取商品详情
      async getDetail() {
        let _data = await getActiveDetail(this.$route.params.id)
        this.info = _data.data
        this.info.images = _data.data.images ? JSON.parse(_data.data.images) : []
      },
        async exportData() {
            window.open(`${upFeil}/index/common/exportActivityDetail?id=${this.detail_id}`)
        },

    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>

/* 第一部分：活动图片和基本信息 */
.activity-header {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
}

.activity-image {
  width: 300px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f5f5f5;
}

.activity-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.activity-basic-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-item {
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;
}

.info-label {
  font-size: 14px;
  color: #666;
  width: 80px;
  flex-shrink: 0;
}

.info-value {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

.activity-name {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.sign-count {
  display: inline-flex;
  align-items: center;
  background-color: #fff7e6;
  color: #f5a623;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.sign-count::before {
  content: '👤';
  margin-right: 6px;
  filter: sepia(1) saturate(5) hue-rotate(-10deg);
}

/* 第二部分：活动介绍和签到人名 */
.activity-intro-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-left: 12px;
  border-left: 4px solid #f5a623;
}

.intro-content {
  font-size: 14px;
  line-height: 1.8;
  color: #555;
  padding: 15px;
  background-color: #fafafa;
  border-radius: 6px;
}

.sign-users-section {
  margin-bottom: 30px;
}

.sign-users-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px;
  background-color: #fafafa;
  border-radius: 6px;
}

.user-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 13px;
  color: #555;
}

.user-tag::before {
  content: '👤';
  margin-right: 5px;
}

/* 内容区块 */
.section-block {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #eee;
}

.section-block:first-of-type {
  margin-top: 20px;
  padding-top: 0;
  border-top: none;
}

/* 活动照片网格 */
.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
}

.photo-item {
  aspect-ratio: 4/3;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5;
  cursor: pointer;
  transition: transform 0.3s;
}

.photo-item:hover {
  transform: scale(1.02);
}

.photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
